module.exports = __webpack_public_path__ + "media/Images/tpa-faq-add-document-image2-3928604156050f8ac09aea7d32cb5ebe.jpg";